import React, {useRef, useEffect, useState} from 'react';
import { StyledIndustriesSpriteJpg } from './StyledIndustriesSpriteJpg';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import  BoxIndustries  from '../BoxIndustries';

gsap.registerPlugin(ScrollTrigger);

const IndustriesSpriteJpg = ({ title, iframeUrl, boxesArray, black, idScroll, imagesArray }) => {
  const canvasRef = useRef(null);
  const contextRef = useRef(null);
  const imagesRef = useRef([])
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)

  const [iframeSrc, setIframeSrc] = useState(null)
  const overlay = useRef(null);

  const airpods = {
    frame: 0
  };
  
  const frameCount = imagesArray.length;
  function render() {
    if(canvasRef !== null) {
      contextRef.current.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      contextRef.current.drawImage(imagesRef.current[airpods.frame], 0, 0, canvasRef.current.width , canvasRef.current.height ); 
    }
  }
  useEffect(() => {
    contextRef.current = canvasRef.current.getContext("2d");
    canvasRef.current.width = canvasRef.current.parentNode.clientWidth;
    canvasRef.current.height = canvasRef.current.width * ((1840/1288));

      gsap.to(airpods, {
        frame: frameCount - 1,
        snap: "frame",
        id: idScroll,
        scrollTrigger: {
          scrub: 0.5,
          trigger: canvasRef.current,
          start: 'top +=30%',
          end: 'bottom center'
        },
        onUpdate: () =>{
          render() // use animation onUpdate instead of scrollTrigger's onUpdate
        }
      });

  }, [imagesRef]);

  useEffect(() => {

    const currentFrame = index => (
      imagesArray[index]
    );

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      imagesRef.current.push(img);
    }
    if(imagesRef.current.length > 0) {
      
      imagesRef.current[0].onload = function(e){
        render()
      };
    }
      

    const resize = () => {
      canvasRef.current.width = canvasRef.current.parentNode.clientWidth;
      canvasRef.current.height = canvasRef.current.width * ((1840/1288));
      
      render() 
     
    }
    window.addEventListener('resize', resize);
    
    return () => {
      window.removeEventListener('resize', resize);
      ScrollTrigger.getById(idScroll).kill();
    };
    
  }, [])

  const handleClick  = (url) => {
    
    if(iframeUrl){
      setIframeSrc(url)
      const overlay = document.querySelector('.overlay--zoom')
      
      if(!isOverlayOpen){
      
        setIsOverlayOpen(true)
        gsap.to(overlay,{x: 0, ease: "power2.easeInOut", duration: .75})
      }
    }
    
  }
  const closeOverlay = () =>  {
    
    const overlay = document.querySelector('.overlay--zoom')
    gsap.to(overlay,{x: '-100%', ease: "power2.easeInOut", duration: .75, onComplete: () => {
      
      setIsOverlayOpen(false)
      setIframeSrc(null)
    }})
  }

  return (
    <React.Fragment>
      {
       
          <StyledIndustriesSpriteJpg>
            <h4 className="md--title" style={{color: black}}>{title}</h4>
            <div className="sprite-content--wrap">
              {
                iframeUrl  &&
                <p className="base mobile-tap" onClick={() => handleClick(iframeUrl)}>View</p>
              }
              <canvas className={`${iframeUrl ? "cursor-view" : ""}`} ref={canvasRef} onClick={() => handleClick(iframeUrl)}></canvas>
              <div className="boxes--wrap">
                {
                  boxesArray.map((key, index) => {
                    return  <div key={index}  className="box--industries-wrap">
                              
                              <p className="preset-9 box--title" style={{color: black}}>{key.title}</p>
                              <div className="box--divisor"></div>
                              <p className="preset-10 box--text" >{key.text}</p>
                            </div>
                  })
                }
              </div>
              
            </div>
            <div className="overlay--zoom" ref={overlay}>
              <div className="close--overlay" onClick={() => closeOverlay()}>
                <img src={require('../../assets/close-overlay-black.png')} />
              </div>
              <iframe src={iframeSrc} />
            </div>
          </StyledIndustriesSpriteJpg>
          
      }
    </React.Fragment>
  );
};

export default IndustriesSpriteJpg;
